import Swal from 'sweetalert2';
const Order = ($) => {
	const STORAGE_KEY = 'vernay_selected_products';

	const getSelectedProducts = () => {
		const stored = localStorage.getItem(STORAGE_KEY);
		return stored ? JSON.parse(stored) : {};
	};

	const setSelectedProducts = (products) => {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
	};

	const updateQuantity = (e) => {
		const $input = $(e.currentTarget);
		const qty = parseInt($input.val());
		const nameAttr = $input.attr('name');
		const productId = nameAttr.match(/\[(\d+)\]/)[1];

		let products = getSelectedProducts();

		if (qty > 0) {
			const $tr = $input.closest('tr');
			products[productId] = {
				id: productId,
				qty: qty,
				name: $tr.find('td:first-child p').text().trim(),
				image: $tr.find('td:first-child img').attr('src'),
				size: $tr.find('td:nth-child(2)').text().trim(),
				status: $tr.find('td:nth-child(4)').text().trim(), // In Stock / Out of Stock
				available: $tr.find('td:nth-child(5)').text().trim(),
				finish: $tr.find('td:nth-child(6)').text().trim() || '', // Expanded mode check?
			};
		} else {
			delete products[productId];
		}

		setSelectedProducts(products);
	};

	$(document).on('input', '.quantity-input', updateQuantity);

	const renderModalTable = () => {
		const products = getSelectedProducts();
		const $tbody = $('.order-modal table.product tbody');
		$tbody.empty();

		Object.values(products).forEach(product => {
			$tbody.append(`
				<tr data-id="${product.id}">
					<td>
						<p>${product.image ? `<img src="${product.image}" alt="">` : ''}${product.name}</p>
					</td>
					<td>${product.size}</td>
					<td>${product.available}</td>
					<td>${product.qty}</td>
					<td>${product.status}</td>
				</tr>
			`);
		});
	};

	$('.order-modal').on('show.bs.modal', renderModalTable);

	$('.request-sample-form').on('submit', function (e) {
		e.preventDefault();
		const $form = $(this);
		const products = getSelectedProducts();

		if (Object.keys(products).length === 0) {
			Swal.fire({
				title: 'Error!',
				text: 'Please select at least one product.',
				icon: 'error',
				confirmButtonText: 'OK'
			});
			return;
		}

		const formData = $form.serializeArray();
		const data = {
			action: vernayApp.actionCreateOrder,
			nonce: vernayApp.nonceCreateOrder,
			products: products,
		};

		formData.forEach(item => {
			data[item.name] = item.value;
		});

		$.ajax({
			url: vernayApp.ajaxUrl,
			type: 'POST',
			data: data,
			beforeSend: function () {
				$form.find('button[type="submit"]').prop('disabled', true).text('Sending...');
			},
			success: function (response) {
				if (response.success) {
					localStorage.removeItem(STORAGE_KEY);
					$('.quantity-input').val('');
					$form[0].reset();
					$('.order-modal').modal('hide');
					Swal.fire({
						title: 'Success!',
						text: response.data.message,
						icon: 'success',
						confirmButtonText: 'OK'
					}).then((result) => {
						window.location.reload();
					});
				} else {
					Swal.fire({
						title: 'Error!',
						text: response.data.message || 'Error creating order',
						icon: 'error',
						confirmButtonText: 'OK'
					});
				}
			},
			error: function () {
				Swal.fire({
					title: 'Error!',
					text: 'An error occurred. Please try again.',
					icon: 'error',
					confirmButtonText: 'OK'
				});
			},
			complete: function () {
				$form.find('button[type="submit"]').prop('disabled', false).text('Request Samples');
			}
		});
	});
}

export default (($) => $(Order))(jQuery)
